<template>
  <div>
    <swiper v-bind="swiperOptions">
      <slot/>
    </swiper>
  </div>
</template>

<script>
// import Swiper core and required modules
import SwiperCore, {Mousewheel} from 'swiper';

import { Swiper } from 'swiper/vue';

SwiperCore.use([Mousewheel]);

export default {
  components: {
    'swiper': Swiper
  },
  data() {
    return {
      swiperOptions: {
        speed: 500,
        threshold: 10,
        watchOverflow: true,
        followFinger: true,
        freeMode: true,
        mousewheel: true,
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 24
          }
        }
      },
    };
  },
  mounted() {
    this.$root.lazyLoad.update();
  }
};
</script>
